import { Component, inject } from '@angular/core';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastInfo } from '../../models/toast-info.model';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-toasts',
  imports: [NgbToastModule],
  templateUrl: './toasts.component.html',
  styleUrl: './toasts.component.scss',
})
export class ToastsComponent {
  protected readonly toastService = inject(ToastService);

  protected remove(toast: ToastInfo): void {
    this.toastService.remove(toast);
  }
}
